import { render, staticRenderFns } from "./GatButton.vue?vue&type=template&id=5c853ba3&scoped=true"
import script from "./GatButton.vue?vue&type=script&lang=js"
export * from "./GatButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c853ba3",
  null
  
)

export default component.exports